import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface FavouriteState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  userFavourites: [] | null | any;
}

const initialState: FavouriteState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  userFavourites: null
};

export const FavouritesSlice = createSlice({
  name: 'favourotes',
  initialState,
  reducers: {
    setFavourites: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setFavouritesByUser: (state, action) => {
      state.userFavourites = action.payload.data;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFavourites, setFavouritesByUser, reset } = FavouritesSlice.actions;
export const getFavouritesDetails = (state: RootState) => state.favourites.data;
export const getUserFavourites = (state: RootState) => state.favourites.userFavourites;
export const getFavouritesTotalRecords=(state:RootState)=> state.favourites.totalRecords;
export default FavouritesSlice.reducer;